import {acquireConstants} from '_constants';

const INITIAL_STATE = {
    acquireCampaigns:  {},
    loadingAcquireCampaign: false,
    acquireCampaignError: '',

    acquireMetrics: {},
    loadingAcquireMetrics: false,
    acquireMetricsError: ''
};

export function acquireReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case acquireConstants.GET_COMPANY_ACQUIRE_CAMPAIGNS_REQUEST:
            return {...state, loadingAcquireCampaign: true, acquireCampaignError: ''};
        case acquireConstants.GET_COMPANY_ACQUIRE_CAMPAIGNS_SUCCESS:
            return {...state, acquireCampaigns: action.payload, loadingAcquireCampaign: false};
        case acquireConstants.GET_COMPANY_ACQUIRE_CAMPAIGNS_FAILURE:
            return {...state, acquireCampaignError: action.error, loadingAcquireCampaign: false};

        case acquireConstants.GET_COMPANY_ACQUIRE_METRICS_REQUEST:
            return {...state, loadingAcquireMetrics: true, acquireMetricsError: ''};
        case acquireConstants.GET_COMPANY_ACQUIRE_METRICS_SUCCESS:
            return {...state, acquireMetrics: action.payload, loadingAcquireMetrics: false};
        case acquireConstants.GET_COMPANY_ACQUIRE_METRICS_FAILURE:
            return {...state, acquireMetricsError: action.error, loadingAcquireMetrics: false};

        case acquireConstants.GET_ORGANIZATION_ACQUIRE_CAMPAIGNS_REQUEST:
            return {...state, loadingAcquireCampaign: true, acquireCampaignError: ''};
        case acquireConstants.GET_ORGANIZATION_ACQUIRE_CAMPAIGNS_SUCCESS:
            return {...state, acquireCampaigns: action.payload, loadingAcquireCampaign: false};
        case acquireConstants.GET_ORGANIZATION_ACQUIRE_CAMPAIGNS_FAILURE:
            return {...state, acquireCampaignError: action.error, loadingAcquireCampaign: false};
        
        case acquireConstants.GET_ORGANIZATION_ACQUIRE_METRICS_REQUEST:
            return {...state, loadingAcquireMetrics: true, acquireMetricsError: ''};
        case acquireConstants.GET_ORGANIZATION_ACQUIRE_METRICS_SUCCESS:
            return {...state, acquireMetrics: action.payload, loadingAcquireMetrics: false};
        case acquireConstants.GET_ORGANIZATION_ACQUIRE_METRICS_FAILURE:
            return {...state, acquireMetricsError: action.error, loadingAcquireMetrics: false};

        default:
            return state
    }
}
